// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ShoppingAutofillDetailsTapAutofillFieldEvent
 */
export var ShoppingAutofillDetailsTapAutofillField = function (_a) {
    var fieldType = _a.fieldType, origin = _a.origin;
    return ({
        name: "ShoppingAutofillDetails Tap AutofillField",
        parameters: {
            cdf_entity: "ShoppingAutofillDetails",
            cdf_action: "Tap",
            field_type: fieldType !== undefined && fieldType !== null ? fieldType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ShoppingAutofillDetailsViewOpenEvent
 */
export var ShoppingAutofillDetailsViewOpen = function (_a) {
    var autofillEnabled = _a.autofillEnabled, origin = _a.origin, hasFullname = _a.hasFullname, hasEmail = _a.hasEmail, hasPhone = _a.hasPhone, hasAddress = _a.hasAddress;
    return ({
        name: "ShoppingAutofillDetails View Open",
        parameters: {
            cdf_entity: "ShoppingAutofillDetails",
            cdf_action: "View",
            autofill_enabled: autofillEnabled !== undefined && autofillEnabled !== null ? autofillEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_fullname: hasFullname !== undefined && hasFullname !== null ? hasFullname.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_email: hasEmail !== undefined && hasEmail !== null ? hasEmail.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_phone: hasPhone !== undefined && hasPhone !== null ? hasPhone.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_address: hasAddress !== undefined && hasAddress !== null ? hasAddress.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
